export default __webpack_public_path__ + "static/media/blue_bg.1115eb3e.png";